import React from 'react'
import ReactDOM from 'react-dom'
import styles from './LinkEditToolbar.scss'
import {getEntityAtCursor, removeLink, snapSelectionToEntity} from 'lib/draftUtils'
const preventDefault = (e) => e.preventDefault()

export const LinkEditToolbar = ({position, editorState, onChange, restoreFocus, onEditLink}) => {
  const lineHeight = 22
  const style = {
    position: 'absolute',
    top: position.top + lineHeight,
    left: position.left
  }
  const link = getEntityAtCursor(editorState)
  const {url} = link.getData()

  const onRemove = () => {
    onChange(removeLink(editorState), restoreFocus)
  }

  const changeLink = () => {
    onChange(snapSelectionToEntity(editorState, true), onEditLink)
  }

  return ReactDOM.createPortal(
    <div className={styles.LinkEditToolbar} style={style} onMouseDown={preventDefault}>
      <ul>
        <li><a href={url} target='_blank' rel='noopener'>{url}</a></li>
        <li onClick={changeLink}>change</li>
        <li onClick={onRemove}>remove</li>
      </ul>
    </div>,
    document.body
  )
}
